// Routes configuration
export const PATH_AFTER_LOGIN = '/amtpay/dashboard/app';
export const PATH_AFTER_ADMIN = '/admin/dashboard';
export const PATH_AFTER_DOCS = '/docs';

export const PATH_APP = {
  root: '/',
  dashboard: '/amtpay/dashboard',
  app: '/amtpay/dashboard/app',
  user: '/amtpay/dashboard/user',
  auth: {
    login: '/auth/login',
    register: '/auth/register',
    resetPassword: '/auth/reset-password',
    verifyCode: '/auth/verify-code'
  }
};

export const PATH_ADMIN = {
  root: '/admin',
  dashboard: '/admin/dashboard',
  user: '/admin/user',
  settings: '/admin/settings'
}; 
